function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSortArrowFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5l6.5 6.406-1.272 1.254-4.309-4.246V27H8.56V8.436L4.272 12.66 3 11.406 9.5 5zM21.58 23.586V5h1.86v18.564l4.288-4.224L29 20.594 22.5 27 16 20.594l1.272-1.254 4.309 4.246z",
    fill: props.color
  }));
}

export default SvgIconSortArrowFilled;